import { render, staticRenderFns } from "./HorizontalScroll.vue?vue&type=template&id=3b419d94"
import script from "./HorizontalScroll.vue?vue&type=script&lang=js"
export * from "./HorizontalScroll.vue?vue&type=script&lang=js"
import style0 from "./HorizontalScroll.vue?vue&type=style&index=0&id=3b419d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports